import { useEffect, useState } from 'react';
import { InputSwitch } from 'primereact/inputswitch';
import { getConsentSync, isTrackingAllowed, loadConsent, Tracker } from '../analytics';

export default function AnalyticsConsentToggle() {
  const [enabled, setEnabled] = useState(() => isTrackingAllowed());

  useEffect(() => {
    loadConsent();
    setEnabled(isTrackingAllowed());
  }, []);

  const handleChange = async (checked: boolean) => {
    setEnabled(checked);
    await Tracker.setConsent(checked ? 'granted' : 'denied');
  };

  const consent = getConsentSync();

  return (
    <div className="flex align-items-center justify-content-between gap-3 p-3 border-1 border-round border-200">
      <div>
        <p className="m-0 font-semibold text-900">Coleta de dados anonimizada</p>
        <p className="m-0 text-sm text-600">
          Ajuda a melhorar o portal com dados de uso agregados, sem enviar dados pessoais.
        </p>
        {consent === 'unset' && (
          <p className="m-0 text-xs text-500 mt-1">Ativo por padrão. Você pode revogar a qualquer momento.</p>
        )}
      </div>
      <InputSwitch checked={enabled} onChange={(e) => void handleChange(!!e.value)} />
    </div>
  );
}
